var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "education--list" },
        _vm._l(_vm.educations, function(education) {
          return _c(
            "div",
            { key: education.id, staticClass: "mb-2" },
            [
              _c(
                "h2",
                [
                  _c("CharacteristicLabel", {
                    attrs: { characteristic: education.schoolType }
                  }),
                  _vm._v(" "),
                  education.highest
                    ? _c("span", [
                        _vm._v(" - Höchste abgeschlossene Ausbildung")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("Infos", { attrs: { education: education } }),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.edit(education)
                      }
                    }
                  },
                  [
                    _c("Icon", { attrs: { icon: "pencil" } }),
                    _vm._v("\n\t\t\t\t\tBearbeiten\n\t\t\t\t")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.educationToRemove = education
                      }
                    }
                  },
                  [
                    _c("Icon", { attrs: { icon: "bin" } }),
                    _vm._v("\n\t\t\t\t\tLöschen\n\t\t\t\t")
                  ],
                  1
                )
              ])
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-items-center mt-4" }, [
        !_vm.askFurther
          ? _c(
              "div",
              [
                !_vm.hasFinishedEducation
                  ? [
                      _vm.hasEducations
                        ? _c("h3", [
                            _vm._v(
                              "Bitte gib noch deine höchste abgeschlossene Ausbildung ein."
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.editingEducation
                        ? _c("SelectInline", {
                            attrs: {
                              "characteristic-items": _vm.characteristicItems,
                              "initial-show-all": "",
                              "single-choice": "",
                              disabled: _vm.noEducation,
                              "description-config": { inline: true, html: true }
                            },
                            on: { input: _vm.onSchoolTypeSelected },
                            model: {
                              value: _vm.schoolType,
                              callback: function($$v) {
                                _vm.schoolType = $$v
                              },
                              expression: "schoolType"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "mt-4",
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.noEducation,
                            callback: function($$v) {
                              _vm.noEducation = $$v
                            },
                            expression: "noEducation"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\tIch habe bisher keine Ausbildung abgeschlossen\n\t\t\t\t"
                          )
                        ]
                      )
                    ]
                  : _c("Button", {
                      attrs: {
                        secondary: "",
                        smaller: "",
                        disabled: _vm.noEducation,
                        text:
                          _vm.educations.length === 0
                            ? "Ausbildung hinzufügen"
                            : "Weitere Ausbildung hinzufügen"
                      },
                      on: { click: _vm.addEducation }
                    })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.askFurther
        ? _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _c("RadioGroup", {
                attrs: { options: _vm.furtherOptions, stacked: "" },
                on: { input: _vm.furtherChanged },
                model: {
                  value: _vm.further,
                  callback: function($$v) {
                    _vm.further = $$v
                  },
                  expression: "further"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.educationToRemove
        ? _c(
            "ConfirmPopUp",
            {
              attrs: { title: "Ausbildung entfernen" },
              on: {
                confirm: _vm.removeEducation,
                hidden: function($event) {
                  _vm.educationToRemove = undefined
                }
              }
            },
            [
              _vm._v("\n\t\tSoll die Ausbildung\n\t\t"),
              _c("CharacteristicLabel", {
                staticClass: "font-weight-extra-bold",
                attrs: { characteristic: _vm.educationToRemove.schoolType }
              }),
              _vm._v("\n\t\twirklich entfernt werden?\n\t")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v(
        "\n\t\t\tHast Du weitere Ausbildungen, egal ob abgeschlossen oder nicht?"
      ),
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "sub" }, [
        _vm._v("Je mehr du eingibst, desto interessanter wird dein Profil!")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }